import { request } from "./client";

const path = (botId) => `/public/bots/${encodeURIComponent(botId)}/registration`;
export const fetchRegistrationForm = (botId) =>
  request(`${path(botId)}/form`, { skipCache: true });
export const requestRegistrationOtp = (botId, phone, templateVersionId) =>
  request(`${path(botId)}/otp`, { method: "POST", data: {
    phone, ...(templateVersionId ? { template_version_id: templateVersionId } : {}),
  } });
export const verifyRegistrationOtp = (botId, proof, code) =>
  request(`${path(botId)}/verify`, { method: "POST", data: { ...proof, code } });
export const registerPublicCustomer = (botId, proof, customer, contactPersonId, relationship, signedForm = {}) =>
  request(path(botId), { method: "POST", data: {
    ...proof, customer, contact_person_id: contactPersonId || null, relationship: relationship || null, ...signedForm,
  } });

export const fetchRegistrationSettings = (botId) =>
  request(`/bots/${encodeURIComponent(botId)}/forms/registration-settings`, { skipCache: true });
export const publishRegistrationSettings = (botId, settings) =>
  request(`/bots/${encodeURIComponent(botId)}/forms/registration-settings`, { method: "PUT", data: settings });
export const previewRegistrationSettings = (botId, settings) =>
  request(`/bots/${encodeURIComponent(botId)}/forms/registration-settings/preview`, { method: "POST", data: settings });

export const registrationError = (error) => {
  const detail = error?.details?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((item) => item.msg).join("; ");
  return error?.message || "Registration failed. Please try again.";
};
